import { useRef, useEffect } from 'react';
import { Grid, Typography, Button, Chip, Box, useMediaQuery } from '@mui/material';
import styles from './PricingCards.module.css';
import gsap from 'gsap';
import { useTheme } from '@mui/material/styles';

const tiers = [
    {
      title: 'Basic',
      price: '1,000',
      term: 'Essential tools for individual creators starting their AI journey.',
      features: [
        '4.5K tokens/quarter',
        'Up to ~900 Image Generations/3 months',
        'Up to ~300 Video Generations/3 months',
        'Image Generations Visibility: Public',
        '4 concurrent Generations'
      ],
      badge: null
    },
    {
      title: 'Standard',
      price: '2,143',
      term: 'Enhanced features for creators seeking more flexibility and support.',
      features: [
        '15K tokens/quarter',
        'Up to ~3000 Image Generations/3 months',
        'Up to ~1000 Video Generations/3 months',
        'Image Generation Visibility: Public',
        '8 concurrent Generations'
      ],
      badge: 'Best value'
    },
    {
      title: 'Professional',
      price: '4,286',
      term: 'Advanced tools and privacy for professionals maximizing productivity.',
      features: [
        '45K tokens/quarter',
        'Up to ~9000 Image Generations/3 months',
        'Up to ~3000 Video Generations/3 months',
        'All styles and models',
        'Image Generation Visibility: Private',
        '12 Concurrent Generations',
        'Priority Support',
        'Higher priority in generation queue'
      ],
      badge: null
    }
  ];

const PricingCard = ({ title, price, term, features, badge }) => {
  const cardRef = useRef();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid item xs={12} md={4} className={styles.cardWrapper}>
      <div 
        ref={cardRef}
        className={styles.card}
        onMouseEnter={() => !isMobile && gsap.to(cardRef.current, { y: -10, duration: 0.3 })}
        onMouseLeave={() => !isMobile && gsap.to(cardRef.current, { y: 0, duration: 0.3 })}
      >
        {badge && (
          <Chip 
            label={badge} 
            className={styles.badge}
            color="secondary" 
          />
        )}
        <Typography variant="h5" className={styles.title}>
          {title}
        </Typography>
        <Box className={styles.priceSection}>
          <Typography variant="h2" className={styles.price}>
            ₹{price}
          </Typography>
          <Typography className={styles.monthText}>/month</Typography>
          <Typography variant="body2" className={styles.billedText}>
            Billed quarterly
          </Typography>
        </Box>
        <Typography className={styles.termText}>{term}</Typography>
        
        <ul className={styles.featureList}>
          {features.map((feature, index) => (
            <li key={index} className={styles.featureItem}>
              {feature}
            </li>
          ))}
        </ul>
        
        <Button
          variant="contained"
          fullWidth
          className={styles.ctaButton}
          sx={{ mt: 'auto' }}
        >
          Get Started
        </Button>
      </div>
    </Grid>
  );
};

const PricingCards = () => {
  return (
    <Box className={styles.container}>
      <Grid container spacing={4} justifyContent="center" alignItems="stretch">
        {tiers.map((tier, index) => (
          <PricingCard key={index} {...tier} />
        ))}
      </Grid>
    </Box>
  );
};

export default PricingCards;